import { Fragment } from "react/jsx-runtime";
import RouterApp from "./routes";
import Global from "./styles/Global";
import { SwiperCustomStyles } from "./styles/Global";


function App() {
  return (
    <Fragment>
      <RouterApp/>
      <SwiperCustomStyles/> 
      <Global/>
    </Fragment>
  );
}

export default App;
